import React, { useEffect } from 'react';
import { useFormikContext } from "formik";
import StateDropdown from "../input/StateDropdown";
import { Party } from "../enums/Party";
import { PfmlEmployeeFormValues } from "../pfml/PfmlEmployeeFormValues";
import RadioGroup from "./RadioGroup";

var _ = require('lodash');

const WorkState = () => {
    const { values, setFieldValue } = useFormikContext<PfmlEmployeeFormValues>()
    const workStateSameAsResidencyState = values.workStateSameAsResidencyState;
    const stateSameAsResidencyState = workStateSameAsResidencyState === 'Yes';
    const party = values.party;

    const state = values.state;
    useEffect(() => {
        if(stateSameAsResidencyState) {
            setFieldValue('workState', state);
        }
    }, [setFieldValue, stateSameAsResidencyState, state])

    return <>
        <RadioGroup id="work-state-same-as-residency-state" label={`Is your ${Party.EMPLOYER === party ? "employee's " : ""}work state same as ${Party.EMPLOYER === party ? "their" : "your"} residency state?`} required={true}
                    radioProps={[
                        { id: "yes", text: "Yes", changeCallback: () => setFieldValue('workState', values.state) },
                        { id: "no", text: "No", changeCallback: () => setFieldValue('workState', '') }
                    ]}/>
        {workStateSameAsResidencyState === 'No' && <StateDropdown id="work-state" label={buildLabel('Work state')} required={true}/>}
    </>

    function buildLabel(baseLabel: string, lowercase = true) {
        let label = baseLabel;
        if(party === Party.EMPLOYER) {
            label = "Employee's " + (lowercase ? _.lowerCase(label) : label);
        }
        return label;
    }
};

export default WorkState;